import React, { useCallback, useEffect, useState } from "react";
import CommonAdminTable from "../components/commonTable";
import { Input, Pagination, Tag, Typography } from "antd";
import Search from "antd/es/transfer/search";
import { useDispatch } from "react-redux";
import { AllProductsListAPI } from "../../redux/actions/adminActions/listsAction";
import Alertify from "../../services/alertify";
import { useLocation } from "wouter";
import { getQueryParams } from "../../utilities/getQueryParams";
const { Title, Text } = Typography;

const ProductsList = () => {
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      fixed: "left",
      align: "center",
    },
    {
      title: "Title",
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "ERP Item Code",
      dataIndex: "erp_item_code",
      key: "erp_item_code",
      render: (text) => <Text className="uppercase">{text}</Text>,
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      render: (text) => <Text className="uppercase">{text}</Text>,
    },
    {
      title: "Packaging Quantity(Pack Of)",
      dataIndex: "packaging_quantity_wholesaler_box",
      key: "packaging_quantity_wholesaler_box",
      align: "center",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (text) => {
        let color = text === "active" ? "green" : "volcano";
        return (
          <Tag color={color} key={text}>
            {text.toUpperCase()}
          </Tag>
        );
      },
    },
  ];

  const [totalProducts, setTotalProducts] = useState(0);
  const [allProducts, setAllProducts] = useState([]);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [searchValue, setSearchValue] = useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/products-list?page=${page}`);
  };
  useEffect(() => {
    document.title = "Products: ALP Shop";
  }, []);

  const dispatch = useDispatch();
  const fetchProducts = useCallback(() => {
    const data = {
      currentPage: currentPage,
      perPage: 10,
      search: searchValue,
    };
    dispatch(AllProductsListAPI(data))
      .then((response) => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.data
        ) {
          const productsWithIndex = response.payload.data.data.map(
            (product, index) => ({
              ...product,
              index: index + 1 + (currentPage - 1) * 10,
            }),
          );
          setAllProducts(productsWithIndex);
          const total = response.payload.data.pagination.total || 0;
          setTotalProducts(total);
          // console.log("All Products are:+++", productsWithIndex);
        } else {
          throw new Error("Unexpected API response structure");
        }
      })
      .catch((error) => {
        Alertify.error(
          "Failed to fetch the all products list: " + error.message,
        );
      });
  }, [currentPage, dispatch, searchValue]);
  useEffect(() => {
    const handler = setTimeout(() => fetchProducts(), 300);
    return () => {
      clearTimeout(handler);
    };
  }, [fetchProducts]);

  return (
    <>
      <Title level={2} className="text-left pb-4">
        Products
      </Title>
      <div className="flex justify-between items-center mb-8">
        <div className="w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
      <CommonAdminTable columns={columns} data={allProducts} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalProducts}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
};

export default ProductsList;
